<template>
    <div>
        <div v-if="!status.detail" class="text-center p-4">
            <b-spinner variant="info" role="status" />
        </div>
        <b-alert v-else-if="loadFailed" show variant="danger">
            {{ $t('message.unknownError') }}
            <b-button size="sm" variant="outline-danger" @click="getSportClubSportTypeData">{{ $t('label.reset') }}</b-button>
        </b-alert>
        <form v-else @submit.prevent="sportClubSportTypeUUID ? requestUpdate() : requestCreate()">
            <b-form-group :label="$t('label.name')" label-cols="4" label-align="left" label-for="sportClubSportType-name">
                <b-form-input id="sportClubSportType-name" v-model.trim="createForm.name" :maxlength="100"
                    :class="{ 'is-invalid': submitted && $v.createForm.name.$error }"
                    :disabled="!status.save" autocomplete="off" />
                <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required">
                    {{ $t('message.requiredX', [$t('label.name')]) }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback v-else-if="submitted && !$v.createForm.name.maxLength">
                    Maximum 100 characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <hr class="my-3 mx-n4" />
            <div class="d-flex justify-content-end w-100">
                <b-button type="button" variant="danger" class="mr-2" :disabled="!status.save" @click="$emit('done')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button type="submit" variant="info" :disabled="!status.save">
                    <span v-if="status.save">{{ sportClubSportTypeUUID ? $t('label.updateX', []) : $t('label.createX', []) }}</span>
                    <b-spinner v-else small />
                </b-button>
            </div>
        </form>
    </div>
</template>
<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { sportClubSportTypeMethods } from '@/state/api';
import { SPORT_CLUB_SPORT_TYPE_MODULE } from '@/state/api/sportClubSportType.state';

export default {
    props: {
        sportClubSportTypeUUID: { type: String, default: '' },
        searchCriteria: { type: Object, required: true },
    },
    data() {
        return { submitted: false, loadFailed: false, createForm: this.defaultForm() };
    },
    validations() {
        return { createForm: { name: { required, maxLength: maxLength(100) } } };
    },
    computed: {
        ...mapState(SPORT_CLUB_SPORT_TYPE_MODULE, ['status']),
        data() { return this.$store.state.api.sportClubSportType.details; },
    },
    created() { this.getSportClubSportTypeData(); },
    methods: {
        ...sportClubSportTypeMethods,
        defaultForm() { return { uuid: '', name: '' }; },
        async getSportClubSportTypeData() {
            if (!this.sportClubSportTypeUUID) return;
            const result = await this.getSportClubSportType({ uuid: this.sportClubSportTypeUUID });
            this.loadFailed = !result;
            if (result) this.createForm = { uuid: this.data.uuid, name: this.data.name };
        },
        requestCreate() { return this.save(this.createSportClubSportType); },
        requestUpdate() { return this.save(this.updateSportClubSportType); },
        async save(action) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid || !this.status.save) return;
            const result = await action({ data: { ...this.createForm }, filter: this.searchCriteria });
            if (result) {
                this.resetForm();
                this.$emit('done');
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
};
</script>
